export default __webpack_public_path__ + "static/media/recent-calls-tour.75aee798.png";